/**
 * @generated SignedSource<<be83a980686746260a0fcf0cff120648>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SudoWrapper_viewer$data = {
  readonly id: string;
  readonly user: {
    readonly id: string;
    readonly emails: ReadonlyArray<string>;
  } | null;
  readonly sudo: {
    readonly " $fragmentSpreads": FragmentRefs<"SudoTriggerClientUpdate_sudo">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SudoSwitchUser_viewer" | "SudoModifyUser_viewer" | "SudoDeleteEverything_viewer">;
  readonly " $fragmentType": "SudoWrapper_viewer";
};
export type SudoWrapper_viewer$key = {
  readonly " $data"?: SudoWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SudoWrapper_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SudoWrapper_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emails",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SudoSwitchUser_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SudoModifyUser_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SudoDeleteEverything_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sudo",
      "kind": "LinkedField",
      "name": "sudo",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SudoTriggerClientUpdate_sudo"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "eaaf407515dd6214fb2660036b143bfb";

export default node;
